import { Global, css, useTheme } from '@emotion/react';
import { colors } from './theme/colors';

export const GlobalStyles = () => {
  const theme = useTheme();
  return (
    <Global
      styles={css`
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
        @font-face {
          font-family: 'Gazpacho';
          src: url('/fonts/gazpacho-regular.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        html {
          font-size: ${theme.typography.htmlFontSize}px;
        }
        main,
        body {
          background-color: #ffffff;
          font-size: ${theme.typography.bodySm.fontSize};
          color: ${theme.palette.text.primary};
        }
        a {
          color: ${colors.black};
          text-decoration: none;
          &:hover {
            text-decoration: underlined;
          }
        }
        ul {
          margin: 0;
          padding-left: 0;
        }
        /* Hide Sentry marketing in Dialog component */
        .powered-by {
          display: none;
        }
        /* MUI overrides */
        .MuiAutocomplete-listbox {
          color: ${theme.palette.text.secondary};
        }
        ul.MuiAutocomplete-listbox li.MuiAutocomplete-option.Mui-focused {
          background-color: ${theme.palette.bg.brandSubtle};
        }
        .MuiButtonBase-root {
          &.MuiButton-primary {
            background-color: ${theme.palette.bg.brandSolid};
            border-color: ${theme.palette.bg.brandSolid};
            :hover {
              background-color: ${theme.palette.bg.brandSolidHover};
              border-color: ${theme.palette.bg.brandSolidHover};
            }
          }
        }
        .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper {
          padding: 4px 0 !important; // because mui using inline styling
        }
      `}
    />
  );
};
